import { useGetApiV1UsersMe } from "@/api/recrutaAI/generated/aISaaSAPI";
import { GLOBAL_HEADER_HEIGHT } from "@/constants/styles/header";
import { Button, Divider, Flex, Text } from "@mantine/core";
import {
	Container,
	Group,
	Image,
	Menu,
	UnstyledButton,
	useMantineTheme,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { Link, useNavigate } from "@tanstack/react-router";
import { signOut } from "aws-amplify/auth";

export function Header() {
	const theme = useMantineTheme();
	const navigate = useNavigate();

	const { data, isPending } = useGetApiV1UsersMe();

	const handleLogout = async () => {
		try {
			await signOut();
			localStorage.removeItem("jwt_token");

			navigate({ to: "/login" });
		} catch {
			// TODO: エラーハンドリング
			notifications.show({
				title: "ログアウトに失敗しました",
				message: "ログアウトに失敗しました。再度お試しください。",
				color: "red",
			});
		}
	};

	return (
		<header
			style={{
				height: GLOBAL_HEADER_HEIGHT,
				borderBottom: `1px solid ${theme.colors.gray[3]}`,
			}}
		>
			<Container
				size="xl"
				style={{
					height: GLOBAL_HEADER_HEIGHT,
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Link to="/">
					<Image src="/Logo.png" alt="logo" height={30} />
				</Link>
				<Flex gap="md">
					<Button
						color="primary.1"
						component="a"
						href="https://ai-recruiter.jp/contact_inapp"
						target="_blank"
					>
						<Text c="primary.5">お問い合わせ</Text>
					</Button>
					<Divider orientation="vertical" color="gray.2" />
					{!isPending && (
						<Menu width={200}>
							<Menu.Target>
								<UnstyledButton>
									<Group>
										<div style={{ flex: 1 }}>
											<Text size="sm" fw={500}>
												{data?.name}
											</Text>
											<Text c="dimmed" size="xs">
												{data?.mailAddress}
											</Text>
										</div>
									</Group>
								</UnstyledButton>
							</Menu.Target>
							<Menu.Dropdown>
								<Menu.Item
									component="a"
									href="https://ai-recruiter.jp/terms_lite"
									target="_blank"
								>
									利用規約
								</Menu.Item>
								<Menu.Item onClick={handleLogout}>ログアウト</Menu.Item>
							</Menu.Dropdown>
						</Menu>
					)}
				</Flex>
			</Container>
		</header>
	);
}
